import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../components/Sidebar';

export default function StaffPage() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetch('https://api.dev.auxo.dk/public/content/staff')
      .then((res) => {
        if (!res.ok) {
          throw new Error('Kunne ikke hente medarbejdere');
        }
        return res.json();
      })
      .then((data) => {
        setStaff(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="py-12 bg-slate-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <nav className="flex mb-8 text-xs text-slate-500" aria-label="Breadcrumb">
          <ol className="inline-flex items-center space-x-1 md:space-x-3">
            <li className="inline-flex items-center">
              <Link to="/" className="hover:text-primary transition-colors flex items-center gap-1.5">
                <i className="fa-solid fa-house text-[10px]" />
                <span>Forside</span>
              </Link>
            </li>
            <li>
              <div className="flex items-center gap-2">
                <i className="fa-solid fa-chevron-right text-[8px] text-slate-400" />
                <span className="font-medium text-slate-700">Medarbejdere</span>
              </div>
            </li>
          </ol>
        </nav>

        <div className="flex flex-col lg:flex-row gap-12">
          {/* Sidebar */}
          <Sidebar />

          {/* Main Content Area */}
          <div className="flex-1 bg-white rounded-3xl p-8 lg:p-12 border border-slate-100 shadow-sm">
            <h1 className="font-serif text-3xl sm:text-4xl font-bold text-secondary mb-4 pb-4 border-b border-slate-100">
              Vores medarbejdere
            </h1>
            <p className="text-slate-600 mb-10 leading-relaxed">
              På Vester-Bo har vi et engageret og tværfagligt team bestående af pædagoger, social- og sundhedsassistenter og en ergoterapeut. Vi arbejder tæt sammen for at skabe trygge rammer og støtte beboerne i deres personlige og sociale udvikling.
            </p>

            {loading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {[1, 2, 3, 4, 5, 6].map((i) => (
                  <div key={i} className="animate-pulse space-y-4">
                    <div className="bg-slate-100 rounded-2xl aspect-[3/4]" />
                    <div className="h-4 bg-slate-100 rounded w-2/3" />
                    <div className="h-3 bg-slate-100 rounded w-1/2" />
                  </div>
                ))}
              </div>
            ) : error ? (
              <div className="p-6 bg-rose-50 rounded-2xl border border-rose-100 text-rose-800 text-sm flex items-center gap-3">
                <i className="fa-solid fa-circle-exclamation text-rose-500 text-lg" />
                <span>{error}</span>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {staff.map((member) => (
                  <div key={member.id} className="group bg-slate-50/50 rounded-2xl p-4 border border-slate-100 hover:border-teal-100 hover:bg-white transition-all duration-300">
                    <div className="relative rounded-xl overflow-hidden aspect-[3/4] mb-4 bg-slate-100 border border-slate-200/50">
                      {member.image && member.image.length > 0 ? (
                        <img
                          src={member.image[0]}
                          alt={member.name}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                        />
                      ) : (
                        <div className="w-full h-full flex items-center justify-center text-slate-300">
                          <i className="fa-solid fa-user text-6xl" />
                        </div>
                      )}
                      <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/60 to-transparent p-4 text-white">
                        <p className="text-xs font-semibold text-teal-300">{member.hired_year}</p>
                      </div>
                    </div>
                    <h3 className="font-serif font-bold text-secondary text-lg group-hover:text-primary transition-colors">
                      {member.name}
                    </h3>
                    <p className="text-xs font-semibold text-primary uppercase tracking-wider mt-1">
                      Social-psykiatrisk medarbejder
                    </p>
                    {member.content && member.content !== '<p>Kort beskrivelse</p>' && (
                      <div 
                        className="text-slate-500 text-sm mt-3 pt-3 border-t border-slate-100 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: member.content }}
                      />
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
